// TGS instant heat + fan row and round snow sensor.
import styled, { css } from 'styled-components';

import {
  activeInput,
  activeLayer180Deg,
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentSpaceBetween,
  layerA,
  layerA180Deg,
  layerADisabled,
  layerADisabled180Deg,
  layerBDisabled,
  layerC,
  layerCLighter,
  readyTop180Deg,
} from '../styles/commonStyles';

export const InstantHeatAndFanOnlyWrapper = styled.div`
  width: 189px;
  height: 55px;
  border-radius: 27px;

  ${layerCLighter};
  ${justifyContentSpaceBetween}
  padding: 0 1px;
  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled180Deg};
    `}
`;

export const InstantHeatWrapper = styled.form`
  width: 132px;
  height: 53px;
  border-radius: 27px;

  ${justifyContentSpaceBetween}
  ${layerA180Deg} 

  padding: 0 5px;

  ${(p) =>
    p.isActivated
      ? css`
          ${activeLayer180Deg};
        `
      : p.isReady &&
        css`
          ${readyTop180Deg}
        `};

  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled180Deg};
    `};
`;

export const ButtonWrapper = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  ${layerA180Deg}
  ${flexBoxCenter}

  ${(p) =>
    p.isActivated &&
    css`
      ${activeLayer180Deg};
    `};

  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled180Deg}
    `}
`;

export const TitleAndInputWrapper = styled.div`
  height: 100%;
  width: auto;

  ${flexDirectionColumn};
  padding: 3px 0;
  margin-right: 6px;
`;
export const ControllerTitleWrapper = styled.div`
  width: 70px;
  height: 22px;
  border-radius: 20px;
  ${layerA};
  ${flexBoxCenter}

  ${(p) =>
    p.isActivated &&
    css`
      background: #124000;
      box-shadow: inset 0px 0px 1px #000000;
    `}
    
    ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled};
    `}
`;
export const ControllerTitle = styled.div`
  width: 68px;
  height: 20px;
  border-radius: 25px;

  font-size: 8px;
  text-align: center;

  ${layerA180Deg}

  ${(p) =>
    p.isActivated
      ? css`
          ${activeLayer180Deg};
        `
      : p.isReady &&
        css`
          ${readyTop180Deg}
        `}

  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled180Deg}
      color: #808080;
    `}
`;

export const TempInput = styled.input`
  width: 70px;
  height: 22px;
  border-radius: 20px;

  ${layerA}

  font-size: 8px;

  &::placeholder {
    color: #fff;
    ${(p) =>
      p.isOff &&
      css`
        color: #808080;
      `}
  }

  ${(p) =>
    p.isActivated &&
    css`
      ${activeInput};
    `}

  ${flexBoxCenter}
  

  ${(p) =>
    p.isOff &&
    css`
      ${layerBDisabled}
      color: #808080;
    `}
`;

export const SnowSensorWrapper = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 50%;

  ${layerC}
  ${flexBoxCenter}

  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled};
    `}
`;

export const SnowSensorInner = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;

  ${layerA180Deg}
  ${justifyContentSpaceBetween}  

  padding: 0 3px 0 5px;

  ${(p) =>
    p.isReady &&
    css`
      ${readyTop180Deg};
    `}

  ${(p) =>
    p.isActivated &&
    css`
      ${activeLayer180Deg}
    `}

  ${(p) =>
    p.isOff &&
    css`
      ${layerADisabled180Deg};
    `}
`;
